<template>
  <div class="checkbox-filter color-filter">
    <b-form-group>
      <b-form-checkbox-group
        :name="`checkbox_${attrCode}`"
        v-model="selected"
        :options="mapOptions"
        class="single-item"
      />
    </b-form-group>
  </div>
</template>

<script>
import Config from 'config'

export default {
  name: 'ColorFilter',
  props: {
    attrCode: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    mapOptions () {
      const _this = this
      if (this.attrCode && this.options) {
        return this.options.map(opt => ({
          value: opt.value,
          html: _this.optionLabel(this.attrCode, opt)
        }))
      }
      return []
    },
    selected: {
      get () {
        return this.attrCode && this.$store.state.listing.filters.chosen[this.attrCode]
          ? this.$store.state.listing.filters.chosen[this.attrCode]
          : []
      },
      set (newValues) {
        this.$store.commit('listing/updateTemporaryFilters', this.getFilterCompose(newValues))
        return newValues
      }
    }
  },
  methods: {
    getFilterCompose (newValues) {
      return { attrCode: this.attrCode, valueSelected: newValues }
    },
    optionLabel (attrCode, opt) {
      let defaultRes = ['0', '1'].includes(opt.label) ? opt.label === opt.value ? this.$t('label_' + opt.label) : opt.label : opt.label
      return defaultRes + `<span class='swatch-color' style='background:${opt.type === 1 ? opt.swatch : opt.type === 2 ? `center / contain no-repeat url(${Config.API.swatchPath + opt.swatch})` : ''}'></span>`
    }
  }
}
</script>
